import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://success.luisabergholz.com";

const META = {
  soyt: {
    title: "Success on Your Terms - Erfüllt im Job ohne Abstriche | Luisa Bergholz",
    description:
      "Eine 14-tägige Coaching Experience für die Frau, bei der im Job von außen alles super läuft - und die spürt, dass da mehr sein muss. Start 11.11.2026.",
    image: `${SITE}/og-soyt.jpg`,
    url: `${SITE}/`,
  },
  masterclass: {
    title: "Bye, Bye „Eigentlich ist doch alles gut“ - Kostenfreie Masterclass",
    description:
      "Für einen Job, der sich genauso gut anfühlt, wie er von außen aussieht. Live via Zoom am 30. September 2026 um 19 Uhr - mit Luisa Bergholz.",
    image: `${SITE}/og-masterclass.jpg`,
    url: `${SITE}/eigentlich`,
  },
};

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function usePageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isSoyt = pathname === "/" || pathname.startsWith("/soyt");
    const m = isSoyt ? META.soyt : META.masterclass;
    const url = isSoyt ? `${SITE}${pathname === "/" ? "/" : pathname}` : `${SITE}${pathname}`;

    document.title = m.title;
    upsert("property", "og:title", m.title);
    upsert("property", "og:description", m.description);
    upsert("property", "og:image", m.image);
    upsert("property", "og:url", url);
    upsert("name", "twitter:title", m.title);
    upsert("name", "twitter:description", m.description);
    upsert("name", "twitter:image", m.image);
    upsert("name", "description", m.description);
  }, [pathname]);
}
